import React from 'react'
import PropTypes from 'prop-types'
import { useModal } from './Modal'

export default function ModalBody({ children }) {
  const modalContext = useModal()
  const { content, iframeSrc } = modalContext || {}

  if (!modalContext) return null
  return (
    <div className="modal-lite__content-body">
      {iframeSrc ? (
        <div className="iframe-wrapper">
          <iframe src={iframeSrc} className="modal-lite-iframe" />
        </div>
      ) : (
        children || content
      )}
    </div>
  )
}

ModalBody.propTypes = {
  children: PropTypes.node
}
